/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { TCountryId, TCurrency } from '@/src/components/sarComponent';

export interface AddBranchCommand {
  arabicName?: string | null;
  englishName?: string | null;
  integrationId?: string | null;
  externalIntegrationId?: string | null;
  storeIntegrationId?: string | null;
  /** @format double */
  commissionValue?: number;
  isCommissionRateBranchLevel?: boolean;
  isTaxBranchLevel?: boolean;
  /** @format double */
  taxValue?: number;
  /** @format double */
  latitude?: number;
  /** @format double */
  longitude?: number;
  /** @format int64 */
  tenantId?: number;
}

export interface AddBulkProductUsingIntegrationCommand {
  /** @format int64 */
  tenantId?: number;
  storeId?: string | null;
  products?: AddProductUsingIntegrationCommand[] | null;
}

export interface AddCategoryCommand {
  integrationId?: string | null;
  /** @format int64 */
  parentId?: number;
  arabicName?: string | null;
  englishName?: string | null;
  storeIntegrationId?: string | null;
  /** @format int64 */
  tenantId?: number;
}

export interface AddIndustryCommand {
  arabicName?: string | null;
  englishName?: string | null;
  arabicDescription?: string | null;
  englsihDescription?: string | null;
  arabicImagePath?: string | null;
  englishImagePath?: string | null;
  /** @format int64 */
  parentId?: number;
  /** @format int32 */
  index?: number;
  /** @format int64 */
  tenantId?: number;
}

export interface AddModifierCommand {
  arabicName?: string | null;
  englishName?: string | null;
  /** @format int32 */
  minimumOptions?: number;
  /** @format int32 */
  maximumOptions?: number;
  isMulti?: boolean;
  storeIntegrationId?: string | null;
  /** @format int64 */
  tenantId?: number;
  modifierOptions?: BaseModifierOption[] | null;
  integrationId?: string | null;
}

export interface AddModifierOptionCommand {
  arabicName?: string | null;
  englishName?: string | null;
  /** @format double */
  price?: number;
  /** @format int64 */
  tenantId?: number;
  storeId?: string | null;
  modifierId?: string | null;
}

export interface AddProductCommand {
  arabicName?: string | null;
  englishName?: string | null;
  arabicDescription?: string | null;
  englishDescription?: string | null;
  sku?: string | null;
  /** @format double */
  price?: number;
  isProductLevelTax?: boolean;
  /** @format double */
  tax?: number;
  /** @format int32 */
  taxType?: number;
  /** @format double */
  commissionValue?: number;
  isProductLevelCommssion?: boolean;
  isHidden?: boolean;
  isSoldOut?: boolean;
  /** @format int32 */
  quantity?: number;
  returnable?: boolean;
  /** @format int32 */
  index?: number;
  /** @format int64 */
  industryId?: number;
  storeIntegrationId?: string | null;
  /** @format int64 */
  tenantId?: number;
  integrationId?: string | null;
  /** @format int32 */
  preparationTimeInMinutes?: number | null;
  defaultImage?: string | null;
  status?: ProductStatusEnum;
  isFromIntegration?: boolean;
  excludedBrnaches?: string[] | null;
  images?: ProductImageInputModel[] | null;
  modifiers?: ProductModifierInput[] | null;
  variantOptions?: VaraintOptionInputModel[] | null;
  variants?: VariantInputModel[] | null;
  categories?: CategoryInputModel[] | null;
}

export interface AddProductDiscountCommand {
  productIntegrationId?: string | null;
  arabicName?: string | null;
  englishName?: string | null;
  storeId?: string | null;
  discountType?: DiscountTypeEnums;
  discountStatus?: DiscountStatusEnums;
  /** @format double */
  discountValue?: number;
  /** @format date-time */
  startOn?: string;
  /** @format date-time */
  endOn?: string;
  /** @format int32 */
  limitQuantity?: number;
  /** @format int32 */
  limitPerUser?: number;
  /** @format int64 */
  tenantId?: number;
}

export interface AddProductImageCommand {
  producIntegrationId?: string | null;
  /** @format int64 */
  tenantId?: number;
  storeIntegrationId?: string | null;
  images?: ProductImageInputModel[] | null;
}

export interface AddProductModifierCommand {
  /** @format int64 */
  tenantId?: number;
  productIntegrationId?: string | null;
  modifierIntegrationId?: string | null;
  storeIntegrationId?: string | null;
  /** @format int32 */
  minimumOptions?: number;
  /** @format int32 */
  maximumOptions?: number;
  isMulti?: boolean;
}

export interface AddProductUsingIntegrationCommand {
  arabicName?: string | null;
  englishName?: string | null;
  arabicDescription?: string | null;
  englishDescription?: string | null;
  sku?: string | null;
  /** @format double */
  price?: number;
  isProductLevelTax?: boolean;
  /** @format double */
  tax?: number;
  /** @format int32 */
  taxType?: number;
  /** @format double */
  commissionValue?: number;
  isProductLevelCommssion?: boolean;
  isHidden?: boolean;
  isSoldOut?: boolean;
  /** @format int32 */
  quantity?: number;
  returnable?: boolean;
  /** @format int32 */
  index?: number;
  /** @format int64 */
  industryId?: number;
  storeIntegrationId?: string | null;
  /** @format int64 */
  tenantId?: number;
  integrationId?: string | null;
  /** @format int32 */
  preparationTimeInMinutes?: number | null;
  defaultImage?: string | null;
  status?: ProductStatusEnum;
  isFromIntegration?: boolean;
  excludedBrnaches?: string[] | null;
  images?: ProductImageInputModel[] | null;
  modifiers?: ProductModifierInput[] | null;
  variantOptions?: VaraintOptionInputModel[] | null;
  variants?: VariantInputModel[] | null;
  categories?: CategoryInputModel[] | null;
  shouldUpdateVaraint?: boolean | null;
  shouldUpdateVaraintOption?: boolean | null;
}

export interface AddSelectedVarintOptionCommand {
  selectedOptionValues?: SelectedOptionValuesInputModel[] | null;
  varaintIntegrationId?: string | null;
  /** @format int64 */
  tenantId?: number;
  storeIntegrationId?: string | null;
}

export interface AddStoreCommand {
  arabicName?: string | null;
  englishName?: string | null;
  country?: string | null;
  acceptReturns?: boolean;
  currency?: string | null;
  /** @format double */
  defultCommissionRate?: number;
  taxLevel?: TaxLevelEnum;
  commissionLevel?: CommissionLevelEnum;
  /** @format double */
  taxValue?: number;
  /** @format int64 */
  oldTaxId?: number;
  /** @format int64 */
  taxId?: number;
  industries?: StoreIndustryInput[] | null;
  integrationId?: string | null;
  /** @format int64 */
  tenantId?: number;
  status?: StoreStatus;
  folderName?: string | null;
}

export interface AddTagCommand {
  arabicName?: string | null;
  englishName?: string | null;
  tagOptions?: TagOption[] | null;
  /** @format int64 */
  tenantId?: number;
}

export interface AddTagOptionCommand {
  arabicName?: string | null;
  englishName?: string | null;
  /** @format int64 */
  tenantId?: number;
  /** @format int64 */
  tagId?: number;
}

export interface AddVaraintCommand {
  /** @format double */
  price?: number;
  sku?: string | null;
  isVisible?: boolean;
  isSoldOut?: boolean;
  productIntegrationId?: string | null;
  /** @format int64 */
  tenantId?: number;
  selectedOptionValues?: SelectedOptionValuesInputModel[] | null;
  images?: ProductImageInputModel[] | null;
  integrationId?: string | null;
  storeIntegrationId?: string | null;
}

export interface AddVaraintImageCommand {
  images?: ProductImageInputModel[] | null;
  varaintIntegrationId?: string | null;
  /** @format int64 */
  tenantId?: number;
  storeIntegrationId?: string | null;
}

export interface AddVaraintModifierCommand {
  /** @format int64 */
  tenantId?: number;
  varaintIntegrationId?: string | null;
  modifierIntegrationId?: string | null;
  storeIntegrationId?: string | null;
  productIntegrationId?: string | null;
  /** @format int32 */
  min?: number;
  /** @format int32 */
  max?: number;
  isMulti?: boolean;
}

export interface AddVariantOptionCommand {
  arabicName?: string | null;
  englishName?: string | null;
  integrationId?: string | null;
  variantOptionValues?: VaraintOptoinValueInputModel[] | null;
  /** @format int64 */
  tenantId?: number;
  productIntegrationId?: string | null;
  storeIntegrationId?: string | null;
}

export interface AvailableHour {
  day?: DayOfWeek;
  /** @format int32 */
  startHour?: number;
  /** @format int32 */
  startMinute?: number;
  /** @format int32 */
  endHour?: number;
  /** @format int32 */
  endMinute?: number;
}

export interface BaseModifierOption {
  arabicName?: string | null;
  englishName?: string | null;
  /** @format double */
  price?: number;
  /** @format int64 */
  tenantId?: number;
  storeId?: string | null;
}

export interface BasicProductDataResponse {
  branchName: string | null;
  arabicName: string | null;
  englishName: string | null;
  arabicDescription?: string | null;
  englishDescription?: string | null;
  sku?: string | null;
  /** @format double */
  price?: number;
  /** @format double */
  originalPrice?: number;
  /** @format double */
  tax?: number;
  /** @format int32 */
  taxType?: number;
  defaultImage?: string | null;
  /** @format double */
  commissionValue?: number;
  isHidden?: boolean;
  isSoldOut?: boolean;
  /** @format int32 */
  quantity?: number;
  returnable?: boolean;
  productIntegrationId?: string | null;
  variantIntegrationId?: string | null;
  status?: ProductStatusEnum;
  productType?: ProductTypesEnum;
  branchId?: string | null;
  selectedVariantOptions?: SelectedVaraintOptionValue[] | null;
  isHaveValidDiscount?: boolean;
  discount?: ProductDiscountResponse;
  integrationId: string;
  isFavorite: boolean;
  storeName: string;
  countryId: TCountryId;
  currencyCode: TCurrency;
  storeEnglishName: string;
  storeId: string;
  storeArabicName: string;
}

export interface BranchResponse {
  /** @format int64 */
  id: number | string;
  arabicName?: string | null;
  englishName?: string | null;
  integrationId?: string | null;
  countryId: TCountryId;
  currencyCode: TCurrency;
}

export interface BulkAddBranchesCommand {
  branches?: AddBranchCommand[] | null;
  /** @format int64 */
  tenantId?: number;
  storeIntegrationId?: string | null;
}

export interface CategoryInputModel {
  id?: string | null;
  arabicName?: string | null;
  englishName?: string | null;
}

export interface CategoryResponse {
  integrationId?: string | null;
  /** @format int64 */
  parentId?: number;
  arabicName?: string | null;
  englishName?: string | null;
}

/** @format int32 */
export enum CommissionLevelEnum {
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
}

/** @format int32 */
export enum CrudTypeEnum {
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
}

/** @format int32 */
export enum DayOfWeek {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
  Value6 = 6,
}

export interface DeleteProductModifier {
  /** @format int64 */
  tenantId?: number;
  productIntegrationId?: string | null;
  modifierIntegrationId?: string | null;
  storeIntegrationId?: string | null;
}

/** @format int32 */
export enum DiscountStatusEnums {
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
}

/** @format int32 */
export enum DiscountTypeEnums {
  Fixed = 1,
  Percentage = 2,
}

export interface GetBranchProductsByIdsQuery {
  branchIntegrationId?: string | null;
  /** @format int64 */
  tenantId?: number;
  productsIds?: string[] | null;
}

export interface GetCartItemsPricingQuery {
  /** @format int64 */
  tenantId?: number;
  items?: ItemPricingInputModel[] | null;
}

export interface GetProductsByBranchesUsingIndustryQuery {
  branches?: string[] | null;
  /** @format int64 */
  tenantId?: number;
  /** @format int64 */
  industryId?: number;
}

export interface GetProductsByIdsQuery {
  /** @format int64 */
  tenantId?: number;
  productsIds?: string[] | null;
}

export interface GetStoreIndustriesByStoresIdsQuery {
  stores?: string[] | null;
  /** @format int64 */
  tenantId?: number;
}

export interface GroupRequest {
  availableHours?: AvailableHour[] | null;
}

export interface HiddenOrSouldOutBrancheResponse {
  branchName?: string | null;
  branchIntegrationId?: string | null;
}

export interface IndustryResponse {
  /** @format int64 */
  id?: number;
  arabicName?: string | null;
  englishName?: string | null;
  arabicDescription?: string | null;
  englsihDescription?: string | null;
  arabicImagePath?: string | null;
  englishImagePath?: string | null;
  /** @format int64 */
  parentId?: number;
}

/** @format int32 */
export enum ItemExtrasTypeEnums {
  Value1 = 1,
}

export interface ItemPricingExtraInput {
  itemExtraId?: string | null;
  parantId?: string | null;
  itemExtraType?: ItemExtrasTypeEnums;
}

export interface ItemPricingInputModel {
  itemId?: string | null;
  branchId?: string | null;
  /** @format int64 */
  tenantId?: number;
  itemType?: ItemTypeEnums;
  extras?: ItemPricingExtraInput[] | null;
}

/** @format int32 */
export enum ItemTypeEnums {
  Value1 = 1,
  Value2 = 2,
}

export interface ModifierJsonOption {
  arabicName?: string | null;
  englishName?: string | null;
  /** @format double */
  price?: number;
  integrationId?: string | null;
}

export interface ModifierOptionResponse {
  id?: string | null;
  arabicName?: string | null;
  englishName?: string | null;
  /** @format double */
  price?: number;
  /** @format date-time */
  createdOn?: string;
}

export interface ModifierResponse {
  id?: string | null;
  arabicName?: string | null;
  englishName?: string | null;
  /** @format int32 */
  minimumOptions?: number;
  /** @format int32 */
  maximumOptions?: number;
  isMulti?: boolean;
  modifierOptions?: ModifierOptionResponse[] | null;
  /** @format date-time */
  createdOn?: string;
}

export interface ProductDetailsResponse {
  arabicName?: string | null;
  englishName?: string | null;
  arabicDescription?: string | null;
  englishDescription?: string | null;
  sku?: string | null;
  /** @format double */
  price?: number;
  /** @format double */
  originalPrice?: number;
  isProductLevelTax?: boolean;
  /** @format double */
  tax?: number;
  /** @format int32 */
  taxType?: number;
  /** @format double */
  commissionValue?: number;
  isProductLevelCommssion?: boolean;
  isHidden?: boolean;
  isSoldOut?: boolean;
  /** @format int32 */
  quantity?: number;
  returnable?: boolean;
  industry?: IndustryResponse;
  storeIntegrationId?: string | null;
  defaultImage?: string | null;
  integrationId?: string | null;
  productType?: ProductTypesEnum;
  /** @format int32 */
  preparationTimeInMinutes?: number;
  images?: ProductImageResponse[] | null;
  variants?: VaraintResponse[] | null;
  variantOptions?: VaraintOptionResponse[] | null;
  modifiers?: ProductModifier[] | null;
  isHaveValidDiscount?: boolean;
  discount?: ProductDiscountResponse;
  hiddenBranches?: HiddenOrSouldOutBrancheResponse[] | null;
  soldOutBranches?: HiddenOrSouldOutBrancheResponse[] | null;
  excludedBrnaches?: string[] | null;
  isFavorite: boolean;
  branchId: number;
  countryId: TCountryId;
  currencyCode: TCurrency;
}

export interface ProductDiscountResponse {
  /** @format int64 */
  id?: number;
  productIntegrationId?: string | null;
  arabicName?: string | null;
  englishName?: string | null;
  discountType?: DiscountTypeEnums;
  discountStatus?: DiscountStatusEnums;
  /** @format double */
  discountValue?: number;
  /** @format date-time */
  startOn?: string;
  /** @format date-time */
  endOn?: string;
  /** @format int32 */
  limitQuantity?: number;
  /** @format int32 */
  limitPerUser?: number;
}

export interface ProductImageInputModel {
  url?: string | null;
  integrationId?: string | null;
  crudType?: CrudTypeEnum;
}

export interface ProductImageResponse {
  url?: string | null;
  integrationId?: string | null;
}

export interface ProductModifier {
  integrationId?: string | null;
  /** @format int64 */
  modifierIntId?: number;
  englishName?: string | null;
  arabicName?: string | null;
  /** @format int32 */
  minimumOptions?: number;
  /** @format int32 */
  maximumOptions?: number;
  isMulti?: boolean;
  useDefault?: boolean;
  modifierOptions?: ModifierJsonOption[] | null;
}

export interface ProductModifierInput {
  modifierIntegrationId?: string | null;
  integrationId?: string | null;
  /** @format int32 */
  minimumOptions?: number;
  /** @format int32 */
  maximumOptions?: number;
  isMulti?: boolean;
  storeIntegrationId?: string | null;
  /** @format int64 */
  tenantid?: number;
}

export interface ProductsSearchParams {
  searchTerm?: string | null;
  /** @format double */
  longitude?: number;
  /** @format double */
  latitude?: number;
  /** @format int32 */
  radius?: number;
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  page?: number;
}

/** @format int32 */
export enum ProductStatusEnum {
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
}

/** @format int32 */
export enum ProductTypesEnum {
  Value1 = 1,
  Value2 = 2,
}

export interface RankIndustriesCommand {
  rankedIndustries?: RankingIndustryInput[] | null;
  /** @format int64 */
  tenantId?: number;
}

export interface RankingIndustryInput {
  /** @format int64 */
  industryId?: number;
  /** @format int32 */
  index?: number;
}

export interface RankSubIndustriesCommand {
  rankedIndustries?: RankingIndustryInput[] | null;
  /** @format int64 */
  industryId?: number;
}

export interface SearchProductInputModel {
  searchKeyWord?: string | null;
  /** @format double */
  longitude?: number;
  /** @format double */
  latitude?: number;
}

export interface SelectedOptionValuesInputModel {
  varaintOptionId?: string | null;
  varaintOptionValueId?: string | null;
  varaintOptionSlug?: string | null;
  varaintOptionValueSlug?: string | null;
  integrationId?: string | null;
  /** @format int64 */
  tenantId?: number;
  crudType?: CrudTypeEnum;
}

export interface SelectedVaraintOptionValue {
  integrationId?: string | null;
  varaintOptionId?: string | null;
  varaintOptionArabicName?: string | null;
  varaintOptionEnglsihName?: string | null;
  varaintOptionValueId?: string | null;
  varaintOptionValueArabicName?: string | null;
  varaintOptionValueEnglishName?: string | null;
}

export interface StoreBranchCommissionInput {
  branchId?: string | null;
  /** @format double */
  commission?: number;
}

export interface StoreBranchTaxInput {
  branchId?: string | null;
  /** @format double */
  tax?: number;
}

export interface StoreIndustryCommissionInput {
  /** @format int64 */
  storeIndustryId?: number;
  /** @format double */
  commissionValue?: number;
}

export interface StoreIndustryInput {
  /** @format int64 */
  industryId?: number;
  crudType?: CrudTypeEnum;
  /** @format int64 */
  tenantId?: number;
}

export interface StoreIndustryTaxInput {
  /** @format int64 */
  storeIndustryId?: number;
  /** @format double */
  taxValue?: number;
}

export interface StoreResponse {
  arabicName?: string | null;
  englishName?: string | null;
  country?: string | null;
  acceptReturns?: boolean;
  currency?: string | null;
  /** @format double */
  defultCommissionRate?: number;
  taxLevel?: TaxLevelEnum;
  commissionLevel?: CommissionLevelEnum;
  /** @format double */
  taxValue?: number;
  industries?: IndustryResponse[] | null;
  integrationId?: string | null;
}

/** @format int32 */
export enum StoreStatus {
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
  Value6 = 6,
}

export interface TagOption {
  arabicName?: string | null;
  englishName?: string | null;
  /** @format int64 */
  tenantId?: number;
}

export interface TagOptionResultResponse {
  arabicName?: string | null;
  englishName?: string | null;
  /** @format int64 */
  id?: number;
  /** @format date-time */
  createdOn?: string;
}

export interface TagResponse {
  /** @format int64 */
  id?: number;
  arabicName?: string | null;
  englishName?: string | null;
  tagOptions?: TagOptionResultResponse[] | null;
  /** @format date-time */
  createdOn?: string;
}

/** @format int32 */
export enum TaxLevelEnum {
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
}

export interface UpdateBranchCommand {
  arabicName?: string | null;
  englishName?: string | null;
  integrationId?: string | null;
  externalIntegrationId?: string | null;
  storeIntegrationId?: string | null;
  /** @format double */
  commissionValue?: number;
  isCommissionRateBranchLevel?: boolean;
  isTaxBranchLevel?: boolean;
  /** @format double */
  taxValue?: number;
  /** @format double */
  latitude?: number;
  /** @format double */
  longitude?: number;
  /** @format int64 */
  tenantId?: number;
}

export interface UpdateCategoryCommand {
  integrationId?: string | null;
  /** @format int64 */
  parentId?: number;
  arabicName?: string | null;
  englishName?: string | null;
  storeIntegrationId?: string | null;
  /** @format int64 */
  tenantId?: number;
}

export interface UpdateGroupRequest {
  /** @format int64 */
  groupId?: number;
}

export interface UpdateIndustryCommand {
  arabicName?: string | null;
  englishName?: string | null;
  arabicDescription?: string | null;
  englsihDescription?: string | null;
  arabicImagePath?: string | null;
  englishImagePath?: string | null;
  /** @format int64 */
  parentId?: number;
  /** @format int32 */
  index?: number;
  /** @format int64 */
  id?: number;
  /** @format int64 */
  tenantId?: number;
}

export interface UpdateModifierCommand {
  arabicName?: string | null;
  englishName?: string | null;
  /** @format int32 */
  minimumOptions?: number;
  /** @format int32 */
  maximumOptions?: number;
  isMulti?: boolean;
  storeIntegrationId?: string | null;
  /** @format int64 */
  tenantId?: number;
  id?: string | null;
}

export interface UpdateModifierOptionCommand {
  arabicName?: string | null;
  englishName?: string | null;
  /** @format double */
  price?: number;
  /** @format int64 */
  tenantId?: number;
  storeId?: string | null;
  id?: string | null;
  modifierId?: string | null;
}

export interface UpdateProductCommand {
  arabicName?: string | null;
  englishName?: string | null;
  arabicDescription?: string | null;
  englishDescription?: string | null;
  sku?: string | null;
  /** @format double */
  price?: number;
  isProductLevelTax?: boolean;
  /** @format double */
  tax?: number;
  /** @format int32 */
  taxType?: number;
  /** @format double */
  commissionValue?: number;
  isProductLevelCommssion?: boolean;
  isHidden?: boolean;
  isSoldOut?: boolean;
  /** @format int32 */
  quantity?: number;
  returnable?: boolean;
  /** @format int32 */
  index?: number;
  /** @format int64 */
  industryId?: number;
  storeIntegrationId?: string | null;
  /** @format int64 */
  tenantId?: number;
  integrationId?: string | null;
  /** @format int32 */
  preparationTimeInMinutes?: number | null;
  defaultImage?: string | null;
  status?: ProductStatusEnum;
  isFromIntegration?: boolean;
  excludedBrnaches?: string[] | null;
  images?: ProductImageInputModel[] | null;
  modifiers?: ProductModifierInput[] | null;
  variantOptions?: VaraintOptionInputModel[] | null;
  variants?: VariantInputModel[] | null;
  categories?: CategoryInputModel[] | null;
  shouldUpdateVaraint?: boolean | null;
  shouldUpdateVaraintOption?: boolean | null;
}

export interface UpdateProductConfigsCommand {
  productId?: string | null;
  /** @format int64 */
  tenantId?: number;
  /** @format double */
  price?: number;
  isHidden?: boolean;
  isSoldOut?: boolean;
  storeId?: string | null;
  hiddenBranches?: string[] | null;
  soldoutBranches?: string[] | null;
}

export interface UpdateProductDiscountCommand {
  productIntegrationId?: string | null;
  arabicName?: string | null;
  englishName?: string | null;
  storeId?: string | null;
  discountType?: DiscountTypeEnums;
  discountStatus?: DiscountStatusEnums;
  /** @format double */
  discountValue?: number;
  /** @format date-time */
  startOn?: string;
  /** @format date-time */
  endOn?: string;
  /** @format int32 */
  limitQuantity?: number;
  /** @format int32 */
  limitPerUser?: number;
  /** @format int64 */
  tenantId?: number;
  /** @format int64 */
  id?: number;
}

export interface UpdateProductModifierCommand {
  /** @format int64 */
  tenantId?: number;
  productIntegrationId?: string | null;
  modifierIntegrationId?: string | null;
  storeIntegrationId?: string | null;
  /** @format int32 */
  minimumOptions?: number;
  /** @format int32 */
  maximumOptions?: number;
  isMulti?: boolean;
}

export interface UpdateProductSoldOutStatusCommand {
  /** @format int64 */
  tenantId?: number;
  itemId?: string | null;
  /** @format int32 */
  itemType?: number;
  branchId?: string | null;
}

export interface UpdateSearchProductsStatusCommand {
  elasticSearchTrackerProductIds?: number[] | null;
  /** @format int64 */
  tenantId?: number;
}

export interface UpdateStoreCommand {
  arabicName?: string | null;
  englishName?: string | null;
  country?: string | null;
  acceptReturns?: boolean;
  currency?: string | null;
  /** @format double */
  defultCommissionRate?: number;
  taxLevel?: TaxLevelEnum;
  commissionLevel?: CommissionLevelEnum;
  /** @format double */
  taxValue?: number;
  /** @format int64 */
  oldTaxId?: number;
  /** @format int64 */
  taxId?: number;
  industries?: StoreIndustryInput[] | null;
  integrationId?: string | null;
  /** @format int64 */
  tenantId?: number;
  status?: StoreStatus;
  folderName?: string | null;
  industriesCommissions?: StoreIndustryCommissionInput[] | null;
  industriesTax?: StoreIndustryTaxInput[] | null;
  branchesCommssions?: StoreBranchCommissionInput[] | null;
  branchesTaxes?: StoreBranchTaxInput[] | null;
}

export interface UpdateStoreStatusCommand {
  storeIntegrationId?: string | null;
  /** @format int64 */
  tenantId?: number;
  status?: StoreStatus;
}

export interface UpdateTagCommand {
  arabicName?: string | null;
  englishName?: string | null;
  /** @format int64 */
  tenantId?: number;
  /** @format int64 */
  id?: number;
}

export interface UpdateTagOptionCommand {
  arabicName?: string | null;
  englishName?: string | null;
  /** @format int64 */
  tenantId?: number;
  /** @format int64 */
  id?: number;
  /** @format int64 */
  tagId?: number;
}

export interface UpdateVaraintCommand {
  /** @format double */
  price?: number;
  sku?: string | null;
  isVisible?: boolean;
  isSoldOut?: boolean;
  productIntegrationId?: string | null;
  /** @format int64 */
  tenantId?: number;
  selectedOptionValues?: SelectedOptionValuesInputModel[] | null;
  images?: ProductImageInputModel[] | null;
  varaintIntegrationId?: string | null;
  storeIntegrationId?: string | null;
}

export interface UpdateVaraintConfigCommand {
  varaintId?: string | null;
  /** @format int64 */
  tenantId?: number;
  hiddenFromBranches?: string[] | null;
  soldoutFromBranches?: string[] | null;
}

export interface UpdateVaraintOptionCommand {
  arabicName?: string | null;
  englishName?: string | null;
  integrationId?: string | null;
  variantOptionValues?: VaraintOptoinValueInputModel[] | null;
  /** @format int64 */
  tenantId?: number;
  productIntegrationId?: string | null;
  storeIntegrationId?: string | null;
  id?: string | null;
}

export interface VaraintImageResponse {
  url?: string | null;
  integrationId?: string | null;
}

export interface VaraintOptinValueResponse {
  integrationId?: string | null;
  arabicName?: string | null;
  englishName?: string | null;
}

export interface VaraintOptionInputModel {
  arabicName?: string | null;
  englishName?: string | null;
  integrationId?: string | null;
  variantOptionValues?: VaraintOptoinValueInputModel[] | null;
  /** @format int64 */
  tenantId?: number;
  productIntegrationId?: string | null;
  storeIntegrationId?: string | null;
}

export interface VaraintOptionResponse {
  arabicName?: string | null;
  englishName?: string | null;
  integrationId?: string | null;
  variantOptionValues?: VaraintOptinValueResponse[] | null;
}

export interface VaraintOptoinValueInputModel {
  arabicName?: string | null;
  englishName?: string | null;
  integrationId?: string | null;
  varaintOptionItegrationId?: string | null;
  /** @format int64 */
  tenantId?: number;
}

export interface VaraintResponse {
  /** @format double */
  price?: number;
  sku?: string | null;
  isVisible?: boolean;
  isSoldOut?: boolean;
  productId?: string | null;
  /** @format int64 */
  tenantId?: number;
  integrationId?: string | null;
  images?: VaraintImageResponse[] | null;
  selectedOptionValues?: SelectedVaraintOptionValue[] | null;
  hiddenFromBranches?: HiddenOrSouldOutBrancheResponse[] | null;
  soldoutFromBranches?: HiddenOrSouldOutBrancheResponse[] | null;
  isHaveValidDiscount?: boolean;
  discount?: ProductDiscountResponse;
  /** @format double */
  originalPrice?: number;
}

export interface VariantInputModel {
  /** @format double */
  price?: number;
  sku?: string | null;
  isVisible?: boolean;
  isSoldOut?: boolean;
  integrationId?: string | null;
  /** @format int64 */
  tenantId?: number;
  crudType?: CrudTypeEnum;
  productId?: string | null;
  selectedOptionValues?: SelectedOptionValuesInputModel[] | null;
  images?: ProductImageInputModel[] | null;
}
